<div class="container" style="background-color: white; padding: 20px">
  <app-slide-world-boxs />
  <app-slide-mundo />
  <app-page-home-template></app-page-home-template>
</div>
